import CustomerStore from './CustomerStore';

export * from './CustomerStore.dto';
export default new CustomerStore();
